/* eslint-disable no-bitwise */
/* istanbul ignore file */
import _ from 'underscore';
import Promise from 'bluebird';
import $ from 'jquery';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { getEditorialTemplates, ENTITY } from '@bingads-webui-campaign/delivery-status-popup-factory';
import { queryify } from '@bingads-webui/url-util';
import { http } from '@bingads-webui/http-util';
import { DisclaimerAdExtension } from '@bingads-webui-campaign/campaign-ui-schemas';

const odata = globalContext.require('module/service/communication/channel/odata');
const SharedRepository = globalContext.require('campaignui/feature/adextension-shared/service/repository');

function fetchRejectionReasons({ scope, ad }) {
  const url = `Advertiser/Customers(${scope.customerId})/Accounts(${scope.accountId})/Ads/Default.EditorialReasons`;
  return odata.post(url, {
    EntityIdsParentIds: [{ EntityId: ad.Id, ParentId: ad.AdGroup.Id }],
  });
}

export function getReasonTemplates({
  ad, scope, errI18n, locationI18n, editorialRejection,
  i18n, commonI18n, logScenario, permissions,
}, deliveryStatus) {
  return new Promise((resolve) => {
    const logActivity = logScenario.fetchRejectionReason.create();
    // Log if Ad Id is invalid
    if (!ad.Id || !_.isNumber(ad.Id)) {
      logActivity.error(`Invalid Ad Id: ${ad.Id}`);
    }
    const IsForDisclaimer = _.contains(['DisclaimerInfoRejected', 'DisclaimerInfoApprovedLimited', 'DisclaimerInfoRejectedAppealRejected', 'DisclaimerInfoApprovedLimitedAppealRejected'], deliveryStatus);
    if (IsForDisclaimer) {
      const disclaimerRepos = new SharedRepository({
        schema: DisclaimerAdExtension,
        afterChangeComitted: _.noop,
      });
      disclaimerRepos.association.findAll({
        where: {
          campaignId: ad.Campaign.Id,
        },
      }).then((disclaimerData) => {
        let url = '/campaign/AdExtensions.m/GetRejectionReasonData';
        const args = _.extend({
          aid: scope.accountId,
          cid: scope.customerId,
          cmpid: scope.campaignId,
          type: 'disclaimer',
          adExtensionId: disclaimerData && disclaimerData[0] && disclaimerData[0].Id,
          campaignId: scope.campaignId || ad.Campaign.Id,
          version: disclaimerData && disclaimerData[0] && disclaimerData[0].Version,
        });
        url = queryify(url, args);
        return http.post({
          url,
          data: { __RequestVerificationToken: $('input[name="__RequestVerificationToken"]').val() },
          contentType: 'application/x-www-form-urlencoded',
        }).then(({
          RejectionReasons,
          IsAppealable,
        }) => {
          const reasonTemplates = getEditorialTemplates({
            reasons: _.map(RejectionReasons, Reason => ({
              ReasonCode: Reason.ReasonCode,
              Location: Reason.Location,
              LanguageToCountries: [{
                PublisherCountries: Reason.RejectionCountries,
              }],
            })),
            editorialRejection,
            errI18n,
            i18n,
            locationI18n,
            commonI18n,
            entity: ENTITY.EXTENSION,
            deliveryStatus,
            permissions,
            isAppealable: IsAppealable,
          });
          resolve(reasonTemplates);
        });
      });
    } else {
      // send request to fetch editorial reasons
      fetchRejectionReasons({ scope, ad }).then((data) => {
        const { value } = data;
        if (!value || _.isEmpty(value) || _.isEmpty(value[0].Reasons)) resolve([i18n.getString('NoRejectionReasonFound')]);

        if (logActivity.signal && !value[0].IsAppealable) {
          logActivity.signal(`not appealable ad: ${ad.Id}`);
        }

        const options = {
          reasons: value[0].Reasons,
          editorialRejection,
          errI18n,
          i18n,
          locationI18n,
          commonI18n,
          logActivity,
          entity: ENTITY.AD,
          deliveryStatus,
          ad,
          isAppealable: value[0].IsAppealable,
          permissions,
          isDetectionRejectionTypeEnabled: permissions && permissions.dynamic && permissions.dynamic.DetectionRejectionType,
        };
        const reasonTemplates = getEditorialTemplates(options);

        resolve(reasonTemplates);
      });
    }
  });
}
